<script>

export default {
  name: 'MyPagination',
  props: ["totalCount", "currentPage"],
  data () {
    return {
      getTotalCount: 0,
      getCurrentPage: 1
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页${val}条`);
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      console.log(`当前页：${val}`);
      this.$emit('handleCurrentChange', val)
    }
  },
  watch: {
    totalCount(val) {
      this.getTotalCount = val
    },
    currentPage(val) {
      this.getCurrentPage = val
    }
  },
}
</script>

<template>
   <div class="pagination_div">
     <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="getCurrentPage"
      :page-sizes="[25, 50, 75, 100]"
      :page-size="25"
      layout="total, prev, pager, next, sizes"
      :total="getTotalCount">
    </el-pagination>
   </div>
</template>

<style lang="scss" scoped>
  .pagination_div {
    height: 45px;
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyPagination.vue